__turbopack_context__.v({
  "benefitCard": "ForClubsBenefits-module-scss-module___prqja__benefitCard",
  "benefitCardDescription": "ForClubsBenefits-module-scss-module___prqja__benefitCardDescription",
  "benefitCardTitle": "ForClubsBenefits-module-scss-module___prqja__benefitCardTitle",
  "benefitsLead": "ForClubsBenefits-module-scss-module___prqja__benefitsLead",
  "benefitsSection": "ForClubsBenefits-module-scss-module___prqja__benefitsSection",
  "sectionEyebrow": "ForClubsBenefits-module-scss-module___prqja__sectionEyebrow",
  "sectionTitle": "ForClubsBenefits-module-scss-module___prqja__sectionTitle",
});
